<template>
   <v-card>
      <v-card-title>{{ iscorporateupgrade ? 'Corporate Upgrade Application' : 'Membership Application' }}</v-card-title>
      <v-card-text>
         <p v-if="iscorporateupgrade">Thank you for submitting your Corporate upgrade application. Your application is under review. Once approved, you will proceed with the payment process.</p>
         <p v-else>Thank you for submitting your new membership application. Your application shall be reviewed and approved by MIP within a few days. Once approved, you will proceed with the payment process.</p>
         <div>
            <h5>{{ iscorporateupgrade ? 'Corporate Upgrade Status' : 'Membership Application Status' }}</h5>
            <b>Date Submitted:</b> {{ (memberinfo) ? formatdate(memberinfo.dateapplied) : '' }}<br>
            <b>Status:</b> {{ (memberinfo) ? formatstatus(memberinfo.memberstatus) : '' }}<br>
         </div>
      </v-card-text>
   </v-card>
</template>

<script>
const axios = require('axios')

export default {
   name: 'PanelPending',
   props: {},
   components: {},
   data: () => ({
      user: Object,
      memberinfo: null,
   }),
   watch: {
      memberinfo: function(newval, oldval) {

      }
   },
   methods: {
      formatdate(e) {
         return this.$moment(new Date(e)).format('DD/MM/YYYY h:mm:ss A')
      },

      formatstatus(e) {
         if (e === 0) {
            return 'Applying'
         }
         if (e === 1) {
            return this.iscorporateupgrade ? 'Pending Review' : 'Pending Approval'
         }
         if (e === 2) {
            return 'Pending Payment'
         }
      },

      loadmemberinfo() {
         this.$nextTick( function () {
            if (this.user.usertype === 'members') {
               var url = '/member/info/' + this.user.id
               axios.get(url)
               .then((resp) => {
                  if (resp.data) {
                     var rtn = resp.data
                     if (rtn.status === 'OK') {
                        this.memberinfo = rtn.data
                     } else {
                        console.log(rtn.status + ': ' + rtn.error)
                     }

                  }
               })
            }
         })
      },
   },
   mounted: function () {
      this.user = this.$page.user
      this.loadmemberinfo()
   },

   computed: {
      iscorporateupgrade() {
         return this.memberinfo && parseInt(this.memberinfo.applcorpstatus || 0) > 0
      },
   },

}
</script>
